import React from 'react';
import { Route, Switch } from 'react-router-dom';

import LandingPageTickets from 'flow/components/nav/landing-pages/LandingPageTickets';
import TicketOverview from 'flow/components/tickets/TicketOverview';
import { routes } from 'flow/types/routes';

const TicketsRoutes = () => (
    <Switch>
        <Route path={routes['tickets.ticketKey']} component={TicketOverview} />
        <Route path="/tickets" component={LandingPageTickets} />
    </Switch>
);

export default TicketsRoutes;
